// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/v1/environment.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file common/v1/environment.proto.
 */
export const file_common_v1_environment: GenFile = /*@__PURE__*/
  fileDesc("Chtjb21tb24vdjEvZW52aXJvbm1lbnQucHJvdG8SCWNvbW1vbi52MSonCgtFbnZpcm9ubWVudBIOCgpQUk9EVUNUSU9OEAASCAoEVEVTVBABQk5aTGdpdGh1Yi5jb20vZW1tZW1zL3N1cGVyLWNhcnQvYXBwcy9zcnYtd29ya2VyL3V0aWxzL21vZGVscy9jb21tb24vdjE7Y29tbW9udjFiBnByb3RvMw");

/**
 * @generated from enum common.v1.Environment
 */
export enum Environment {
  /**
   * @generated from enum value: PRODUCTION = 0;
   */
  PRODUCTION = 0,

  /**
   * @generated from enum value: TEST = 1;
   */
  TEST = 1,
}

/**
 * Describes the enum common.v1.Environment.
 */
export const EnvironmentSchema: GenEnum<Environment> = /*@__PURE__*/
  enumDesc(file_common_v1_environment, 0);

